// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Block       = require("bs-platform/lib/js/block.js");
var Board       = require("./Board");
var Curry       = require("bs-platform/lib/js/curry.js");
var Title       = require("./Title");
var React       = require("react");
var Footer      = require("./Footer");
var GameOver    = require("./GameOver");
var GameLogic   = require("../lib/gameLogic");
var EventLayer  = require("./EventLayer");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./App2k.css')));

function genState(board, canUpdate) {
  return /* record */[
          /* canUpdate */canUpdate,
          /* board */board,
          /* score */GameLogic.score(board),
          /* gameOver */GameLogic.gameIsOver(board)
        ];
}

var component = ReasonReact.reducerComponent("App2k");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var state = param[/* state */2];
      var reduce = param[/* reduce */1];
      return ReasonReact.element(/* None */0, /* None */0, EventLayer.make(Curry._1(reduce, (function (direction) {
                            return /* UserEvent */[direction];
                          })), /* Some */["App"], /* array */[
                      ReasonReact.element(/* None */0, /* None */0, Title.make(state[/* score */2], Curry._1(reduce, (function () {
                                      return /* Restart */1;
                                    })), /* array */[])),
                      React.createElement("div", {
                            className: "game-area"
                          }, ReasonReact.element(/* None */0, /* None */0, Board.make(state[/* board */1], /* array */[]))),
                      ReasonReact.element(/* None */0, /* None */0, Footer.make(/* array */[])),
                      ReasonReact.element(/* None */0, /* None */0, GameOver.make(state[/* gameOver */3], state[/* score */2], Curry._1(reduce, (function () {
                                      return /* Restart */1;
                                    })), /* array */[]))
                    ]));
    });
  newrecord[/* initialState */10] = (function () {
      return genState(GameLogic.make(/* () */0), /* true */1);
    });
  newrecord[/* reducer */12] = (function (action, state) {
      var match = state[/* canUpdate */0];
      if (typeof action === "number") {
        if (action !== 0) {
          return /* Update */Block.__(0, [genState(GameLogic.make(/* () */0), /* true */1)]);
        } else {
          return /* Update */Block.__(0, [genState(GameLogic.addCell(state[/* board */1]), /* true */1)]);
        }
      } else if (match !== 0) {
        return /* UpdateWithSideEffects */Block.__(3, [
                  genState(GameLogic.shift(action[0], state[/* board */1]), /* false */0),
                  (function (self) {
                      setTimeout(Curry._1(self[/* reduce */1], (function () {
                                  return /* AddCell */0;
                                })), 100);
                      return /* () */0;
                    })
                ]);
      } else {
        return /* NoUpdate */0;
      }
    });
  return newrecord;
}

exports.genState  = genState;
exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/App2k.re
// module id = 30
// module chunks = 0